import type { UserRole, Studio } from '@/types'

const ACCESSIBLE_STUDIO_STATUSES = new Set(['OPEN', 'PRE-OPEN', 'SERVICE', 'SUSPENDED'])

/**
 * Нормализует partner_number из произвольного значения в number | null.
 */
export function normalizePartnerNumber(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null
  const parsed = Number(value)
  return Number.isNaN(parsed) ? null : parsed
}

/**
 * Определяет роль пользователя на основе access_kind и team_role из RPC-ответа.
 */
function resolveRole(studio: { access_kind?: string; team_role?: string; role?: string }): UserRole {
  if (studio.access_kind === 'management_company' || studio.team_role === 'management_company') {
    return 'management_company'
  }
  if (studio.access_kind === 'senior_teacher' || studio.team_role === 'senior_teacher' || studio.role === 'senior_teacher') {
    return 'senior_teacher'
  }
  if (studio.team_role) {
    return studio.team_role as UserRole
  }
  if (studio.role) {
    return studio.role as UserRole
  }
  if (studio.access_kind === 'owner') {
    return 'owner'
  }
  return 'manager'
}

/**
 * Преобразует массив строк из RPC (get_user_studios_with_access_v2, get_my_studios,
 * tg-auth-new, get-user-studios) в формат Studio[] для Zustand store.
 */
export function mapRawStudiosToStore(rows: any[]): Studio[] {
  return rows
    .filter((studio: any) => ACCESSIBLE_STUDIO_STATUSES.has(studio.status_code || 'OPEN'))
    .map((studio: any) => ({
      studio_internal_id: studio.studio_internal_id,
      studio_number: studio.studio_number || `Studio ${studio.studio_internal_id}`,
      city_id: studio.city_id || 0,
      address: studio.address,
      created_at: studio.created_at,
      updated_at: studio.updated_at,
      status_code: studio.status_code,
      partner_number: normalizePartnerNumber(studio.partner_number),
      currency_code: studio.currency_code || 'RUB',
      access_kind: studio.access_kind,
      role: resolveRole(studio),
      city: (studio.city_name || studio.city?.city_name) ? {
        city_id: studio.city_id || 0,
        city_name: studio.city_name || studio.city?.city_name,
        population_thousands: studio.population_thousands ?? studio.city?.population_thousands ?? null,
        city_population_group: studio.city_population_group ?? studio.city?.city_population_group ?? null,
        city_land_group: studio.city_land_group ?? studio.city?.city_land_group ?? null,
        country: studio.country || studio.city?.country || 'Россия'
      } : undefined
    }))
}
